export default __webpack_public_path__ + "static/12-3d4118e165b6073148d6dad027b67f0b.jpg";